import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
// ✅ REMOVED unused import: import { Link } from 'react-router-dom';

const fontFamily = {
  fontFamily: "'Poppins', sans-serif",
};

const Events = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": "MDeRCM Annual Events",
    "organizer": {
      "@type": "Organization",
      "name": "MDeRCM",
      "url": "https://mdercm.com"
    },
    "location": {
      "@type": "Place",
      "name": "United States"
    }
  };

  // Event data
  const events = [
    {
      id: 1,
      title: 'Annual Event 2025',
      date: '2025',
      description: 'Our grand annual event celebrating success and innovation in healthcare.',
      images: [
        '/images/events/EV2.jpeg',
        '/images/events/EV3.jpeg',
        '/images/events/EV4.jpeg',
        '/images/events/EV5.jpeg',
        '/images/events/EV6.jpeg',
        '/images/events/EV7.jpeg',
        '/images/events/EV8.jpeg',
        '/images/events/EV9.jpeg',
        '/images/events/EV10.jpeg',
        '/images/events/EV11.jpeg',
      ]
    },
  ];

  const openCarousel = (event) => {
    setSelectedEvent(event);
    setCurrentImageIndex(0);
  };

  const closeCarousel = () => {
    setSelectedEvent(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    if (selectedEvent) {
      setCurrentImageIndex((prev) => 
        prev === selectedEvent.images.length - 1 ? 0 : prev + 1
      );
    }
  };

  const previousImage = () => {
    if (selectedEvent) {
      setCurrentImageIndex((prev) => 
        prev === 0 ? selectedEvent.images.length - 1 : prev - 1
      );
    }
  };

  const goToImage = (index) => {
    setCurrentImageIndex(index);
  };

  // Styles
  const pageContainerStyle = {
    ...fontFamily,
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    paddingTop: '40px',
    paddingBottom: '60px',
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '50px',
  };

  const titleStyle = {
    fontSize: '42px',
    fontWeight: 700,
    color: '#2c3e50',
    marginBottom: '15px',
    background: 'linear-gradient(135deg, #F26522 0%, #d3541c 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  };

  const subtitleStyle = {
    fontSize: '18px',
    color: '#666',
    fontWeight: 400,
  };

  const eventsGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
    gap: '30px',
    marginTop: '40px',
  };

  const eventCardStyle = {
    backgroundColor: '#fff',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
  };

  const eventCardHoverStyle = {
    transform: 'translateY(-8px)',
    boxShadow: '0 12px 30px rgba(242, 101, 34, 0.2)',
  };

  const eventImageStyle = {
    width: '100%',
    height: '220px',
    objectFit: 'cover',
    backgroundColor: '#f0f0f0',
  };

  const eventContentStyle = {
    padding: '25px',
  };

  const eventTitleStyle = {
    fontSize: '24px',
    fontWeight: 600,
    color: '#2c3e50',
    marginBottom: '10px',
  };

  const eventDateStyle = {
    fontSize: '14px',
    color: '#F26522',
    fontWeight: 500,
    marginBottom: '12px',
  };

  const eventDescStyle = {
    fontSize: '15px',
    color: '#666',
    lineHeight: '1.6',
    marginBottom: '15px',
  };

  const viewButtonStyle = {
    backgroundColor: '#F26522',
    color: '#fff',
    padding: '10px 24px',
    borderRadius: '8px',
    border: 'none',
    fontWeight: 600,
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    width: '100%',
    marginTop: '10px',
  };

  const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  };

  const modalContentStyle = {
    position: 'relative',
    maxWidth: '1100px',
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: '16px',
    overflow: 'hidden',
    maxHeight: '90vh',
  };

  const modalHeaderStyle = {
    padding: '20px 30px',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
  };

  const closeButtonStyle = {
    background: 'none',
    border: 'none',
    fontSize: '32px',
    cursor: 'pointer',
    color: '#666',
    lineHeight: '1',
    padding: '0',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',
  };

  const carouselContainerStyle = {
    position: 'relative',
    width: '100%',
    height: '600px',
    backgroundColor: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const carouselImageStyle = {
    maxWidth: '100%',
    maxHeight: '600px',
    objectFit: 'contain',
  };

  const arrowButtonStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    border: 'none',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    fontSize: '24px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',
    zIndex: 10,
    color: '#333',
    fontWeight: 'bold',
  };

  const leftArrowStyle = {
    ...arrowButtonStyle,
    left: '20px',
  };

  const rightArrowStyle = {
    ...arrowButtonStyle,
    right: '20px',
  };

  const thumbnailContainerStyle = {
    display: 'flex',
    gap: '10px',
    padding: '20px 30px',
    overflowX: 'auto',
    backgroundColor: '#f8f9fa',
    justifyContent: 'center',
    flexWrap: 'wrap',
  };

  const thumbnailStyle = {
    width: '80px',
    height: '80px',
    objectFit: 'cover',
    borderRadius: '8px',
    cursor: 'pointer',
    border: '3px solid transparent',
    transition: 'all 0.3s ease',
  };

  const activeThumbnailStyle = {
    ...thumbnailStyle,
    border: '3px solid #F26522',
    transform: 'scale(1.05)',
  };

  const imageCounterStyle = {
    position: 'absolute',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    color: '#fff',
    padding: '8px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: 500,
    zIndex: 10,
  };

  return (
    <>
      <Helmet>
        <title>MDeRCM Events | Healthcare RCM Celebrations | MDeRCM</title>
        <meta 
          name="description" 
          content="Explore MDeRCM's company events, annual celebrations, and healthcare revenue cycle management milestones. Join us in celebrating success and innovation." 
        />
        <meta 
          name="keywords" 
          content="MDeRCM events, healthcare RCM events, company celebrations, revenue cycle management company events" 
        />
        <link rel="canonical" href="https://mdercm.com/events" />
        
        <meta property="og:title" content="MDeRCM Events & Company Celebrations" />
        <meta property="og:description" content="Celebrating milestones and creating memories together at MDeRCM healthcare revenue cycle management events." />
        <meta property="og:url" content="https://mdercm.com/events" />
        <meta property="og:type" content="website" />
        
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>

      <div style={pageContainerStyle}>
        <div style={containerStyle}>
          {/* Page Header */}
          <div style={headerStyle}>
            <h1 style={titleStyle}>Our Events</h1>
            <p style={subtitleStyle}>
              Celebrating milestones and creating memories together
            </p>
          </div>

          {/* Events Grid */}
          <div style={eventsGridStyle}>
            {events.map((event) => (
              <div
                key={event.id}
                style={eventCardStyle}
                onClick={() => openCarousel(event)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = eventCardHoverStyle.transform;
                  e.currentTarget.style.boxShadow = eventCardHoverStyle.boxShadow;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
                }}
              >
                <img
                  src={event.images[0]}
                  alt={`${event.title} - MDeRCM Healthcare RCM Event`}
                  style={eventImageStyle}
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/350x220?text=Event+Photo';
                  }}
                />
                <div style={eventContentStyle}>
                  <h3 style={eventTitleStyle}>{event.title}</h3>
                  <p style={eventDateStyle}>📅 {event.date}</p>
                  <p style={eventDescStyle}>{event.description}</p>
                  <button
                    style={viewButtonStyle}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#d3541c';
                      e.target.style.transform = 'scale(1.02)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#F26522';
                      e.target.style.transform = 'scale(1)';
                    }}
                  >
                    View Gallery ({event.images.length} photos)
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Carousel Modal */}
          {selectedEvent && (
            <div
              style={modalOverlayStyle}
              onClick={closeCarousel}
            >
              <div
                style={modalContentStyle}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={modalHeaderStyle}>
                  <div>
                    <h2 style={{ ...fontFamily, fontSize: '24px', fontWeight: 600, color: '#2c3e50', margin: 0 }}>
                      {selectedEvent.title}
                    </h2>
                    <p style={{ ...fontFamily, fontSize: '14px', color: '#666', margin: '5px 0 0 0' }}>
                      {selectedEvent.date}
                    </p>
                  </div>
                  <button
                    style={closeButtonStyle}
                    onClick={closeCarousel}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#f0f0f0';
                      e.target.style.color = '#F26522';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = '#666';
                    }}
                  >
                    ×
                  </button>
                </div>

                <div style={carouselContainerStyle}>
                  <button
                    style={leftArrowStyle}
                    onClick={previousImage}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#F26522';
                      e.target.style.color = '#fff';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                      e.target.style.color = '#333';
                    }}
                  >
                    ‹
                  </button>
                  <img
                    src={selectedEvent.images[currentImageIndex]}
                    alt={`${selectedEvent.title} - Photo ${currentImageIndex + 1}`}
                    style={carouselImageStyle}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/800x600?text=Event+Photo';
                    }}
                  />
                  <button
                    style={rightArrowStyle}
                    onClick={nextImage}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#F26522';
                      e.target.style.color = '#fff';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                      e.target.style.color = '#333';
                    }}
                  >
                    ›
                  </button>
                  <div style={imageCounterStyle}>
                    {currentImageIndex + 1} / {selectedEvent.images.length}
                  </div>
                </div>

                <div style={thumbnailContainerStyle}>
                  {selectedEvent.images.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt={`${selectedEvent.title} thumbnail ${index + 1}`}
                      style={index === currentImageIndex ? activeThumbnailStyle : thumbnailStyle}
                      onClick={() => goToImage(index)}
                      onMouseEnter={(e) => {
                        if (index !== currentImageIndex) {
                          e.target.style.opacity = '0.7';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.opacity = '1';
                      }}
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/80?text=Thumbnail';
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Events;